import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { s as slotFilled } from './index3.js';
import { d as defineCustomElement$2 } from './box.js';

const concatStyles = (...args) => {
    return args.filter(Boolean).join(' ');
};

const tileCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host h3{font-family:Open Sans;font-size:1.125rem;font-weight:400;letter-spacing:-.0008em;line-height:1.5rem;margin:0;padding:0}:host p{font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;margin:0;padding:0}:host(.header),:host(.header-button){border-bottom:1px solid var(--jw-theme-surface-border-border-color);padding:1.5rem}::slotted([slot=footer]){padding-left:1.5rem;padding-right:1.5rem}:host(.tabbed-header) wui-tabs{padding-left:1.5rem;padding-right:1.5rem;padding-top:.5rem}:host(.tile-container){background-color:var(--jw-theme-surface-tile-bg-color);border:1px solid var(--jw-theme-surface-border-border-color);border-radius:.375rem;display:flex;flex-direction:column;max-width:100%;position:relative;width:100%}.horizontal-padding{padding-left:1.5rem;padding-right:1.5rem}.vertical-padding{padding-bottom:1.5rem;padding-top:1.5rem}";
const WuiTileStyle0 = tileCss;

const WuiTile$1 = /*@__PURE__*/ proxyCustomElement(class WuiTile extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.hasHeader = false;
        this.hasFooter = false;
        this.fullWidth = false;
        this.fullHeight = false;
        this.box = undefined;
    }
    checkContentConfiguration() {
        this.hasFooter = slotFilled(this.el, 'footer');
        this.hasHeader = slotFilled(this.el, 'header');
    }
    componentDidLoad() {
        this.checkContentConfiguration();
    }
    render() {
        const boxProps = typeof this.box === 'object' ? this.box : {};
        return (h(Host, { key: '479aa30319934bc88929f03bb38ed88f8b458d6d', class: "tile-container" }, h("slot", { key: 'e31919273e1e2fa825d8c3dfd30adf0fbc32207f', name: "header" }), h("wui-box", { key: '39e6d9068d736fe0e77c5d7b8f1de4b9594ec09c', class: concatStyles(!this.hasFooter && !this.fullHeight && 'vertical-padding', (!this.hasHeader || !this.hasFooter) && !this.fullWidth && 'horizontal-padding'), style: { flex: '1' }, ...boxProps }, h("slot", { key: '69cc1d167a2e49ac345dc4a3a770ddb598180426' })), h("slot", { key: '9c4cb2f2f7cb2f1d09cad03e8b84c51e2ed6e026', name: "footer" })));
    }
    get el() { return this; }
    static get style() { return WuiTileStyle0; }
}, [1, "wui-tile", {
        "fullWidth": [4, "full-width"],
        "fullHeight": [4, "full-height"],
        "box": [4],
        "hasHeader": [32],
        "hasFooter": [32]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-tile", "wui-box"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-tile":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiTile$1);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiTile = WuiTile$1;
const defineCustomElement = defineCustomElement$1;

export { WuiTile, defineCustomElement };

//# sourceMappingURL=wui-tile.js.map